// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"131": "188284c2e1bd2de0","391": "9475abeee94a07d9",}[chunkId] + ".js"
}